import { render } from "./TaikyoButtonPanel.vue?vue&type=template&id=4252efd6&ts=true"
import script from "./TaikyoButtonPanel.vue?vue&type=script&lang=ts"
export * from "./TaikyoButtonPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox,QBtn});
